module.exports = __webpack_public_path__ + "static/metal-frame06-884abfc150f3f2438f0fc55d33a2f35c.jpg";